import { forwardRef } from 'react';
import { createBemBlockBuilder } from '@ebsco-ui/utils';
import cn from 'classnames';
import { jsx, jsxs } from 'react/jsx-runtime';

var SIZE = 50;
var THICKNESS = 3;
var RADIUS = (SIZE - THICKNESS) / 2;
var IndeterminateSpinner = forwardRef(function (_ref, ref) {
  var className = _ref.className,
      level = _ref.level;
  var isIe = typeof window !== "undefined" && (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > -1);
  var browserClassName = isIe ? "eb-indeterminate-spinner-ie-11" : "eb-indeterminate-spinner";
  var getBlocksWith = createBemBlockBuilder([browserClassName, className]);
  return /*#__PURE__*/jsx("div", {
    className: getBlocksWith(),
    "data-auto": "indeterminate-spinner",
    ref: ref,
    children: isIe ? /*#__PURE__*/jsxs("div", {
      className: cn(getBlocksWith("__ring"), getBlocksWith("__ring--".concat(level))),
      children: [/*#__PURE__*/jsx("div", {}), /*#__PURE__*/jsx("div", {}), /*#__PURE__*/jsx("div", {}), /*#__PURE__*/jsx("div", {})]
    }) : /*#__PURE__*/jsx("svg", {
      className: cn(getBlocksWith("__svg"), getBlocksWith("__svg--".concat(level))),
      viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE),
      children: /*#__PURE__*/jsx("circle", {
        cx: SIZE,
        cy: SIZE,
        r: RADIUS
      })
    })
  });
});
IndeterminateSpinner.displayName = "IndeterminateSpinner";

export { IndeterminateSpinner as default };
//# sourceMappingURL=indeterminate-spinner-esm.js.map
